import { createFileRoute } from '@tanstack/react-router';

import { getDictionaryOptions } from '@/module/Author/Dictionary';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout')({
  loader: async ({ params: { dictionaryId }, context: { queryClient } }) => {
    const dictionary = await queryClient.ensureQueryData(getDictionaryOptions(dictionaryId));

    return {
      dictionary,
      crumb: dictionary.title,
    };
  },
});
